var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53146 3.52344C6.59812 3.52344 3.07812 6.45677 3.07812 11.1501C3.07812 15.8434 6.59813 19.3634 11.2915 19.3634C15.9848 19.3634 18.9181 15.8434 18.9181 12.9101C12.4648 17.0168 5.42479 9.97677 9.53146 3.52344Z",
    stroke: "#164A84",
    strokeWidth: 1.17333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2207 1.86719L14.8768 3.88646H17L15.2823 5.13445L15.9384 7.15372L14.2207 5.90574L12.503 7.15372L13.1591 5.13445L11.4414 3.88646H13.5646L14.2207 1.86719Z",
    fill: "#164A84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9492 7.39062L17.4333 8.8806H19L17.7325 9.80146L18.2167 11.2914L16.9492 10.3706L15.6818 11.2914L16.1659 9.80146L14.8984 8.8806H16.4651L16.9492 7.39062Z",
    fill: "#164A84"
  })));
};
export default __webpack_public_path__ + "static/media/night.c92fcd4f.svg";
export { SvgComponent as ReactComponent };